export function createCompanyFilters(): FilterProperties[] {
  return [
    { label: 'Name', property: 'name', type: 'string' },
    { label: 'Status', property: 'status', type: 'select', options: ['active', 'archived', 'deactivated'] },
    { label: 'Created at', property: 'createdAt', type: 'date' },
    { label: 'Updated at', property: 'updatedAt', type: 'date' }
  ];
}
